export enum SectionIdentifier {
  MUSIC = "music",
  MERCH = "merch",
  EVENTS = "events",
}
